import { render, staticRenderFns } from "./GyCGroup.vue?vue&type=template&id=51072574&"
import script from "./GyCGroup.vue?vue&type=script&lang=js&"
export * from "./GyCGroup.vue?vue&type=script&lang=js&"
import style0 from "./GyCGroup.vue?vue&type=style&index=0&id=51072574&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports